function validationPermission(user, permission) {
  let result = -1;
  if (user?.permissions && user.permissions.length > 0)
    result = user.permissions.findIndex(function (element) {
      return element === permission;
    });

  return !(result === -1);
}

export default validationPermission;
